import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Location } from '@angular/common';

@Component({
    selector: 'nav-bar-desktop',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./nav-bar-desktop.scss'],
    template: `
       <ion-toolbar>
       
         @if (!hideBackButton) {
           <ion-buttons slot="secondary" class="custom-back-button">
             <ion-button tappable (click)="goToPageAction()">
               <ion-icon name="arrow-back" class="back-button-icon-md"></ion-icon>
             </ion-button>
           </ion-buttons>
         }
       
         <div class="toolbar-title toolbar-title-md page-title">
           {{text}}
         </div>
       
         @if (showHelpButton) {
           <ion-buttons slot="primary">
             <ion-button tappable (click)="doAction()" class="help">
               {{helpText}}
             </ion-button>
           </ion-buttons>
         }
       
         @if (trashButton) {
           <ion-buttons slot="primary">
             <ion-button tappable (click)="trashAction()">
               <ion-icon name="trash"></ion-icon>
             </ion-button>
           </ion-buttons>
         }
       
       </ion-toolbar>
       `,
    standalone: false
})
export class NavBarDesktop implements OnInit {

  @Input() text: string;
  @Input() helpText: string;
  @Input() showHelpButton: boolean;
  @Input() customBackArrow: boolean;
  @Input() trashButton: boolean;
  @Input() hideBackButton: boolean;
  @Output() actionHelp: EventEmitter<any> = new EventEmitter();
  @Output() actionPage: EventEmitter<any> = new EventEmitter();
  @Output() actionTrash: EventEmitter<any> = new EventEmitter();

  constructor(private navCtrl: CustomNavController, private location: Location) { }

  ngOnInit() {
    this.text = this.text || '';
    this.hideBackButton = this.hideBackButton || !(window.history.length > 1);
  }

  goToPageAction(): void {
    if (this.customBackArrow) {
      this.actionPage.emit();
    } else {
      this.location.back();
    }
  }

  doAction(): void {
    this.actionHelp.emit();
  }

  trashAction(): void {
    this.actionTrash.emit();
  }

}
